export default __webpack_public_path__ + "static/media/cms.907b1d17.svg";